import { createSlice } from "@reduxjs/toolkit";
import { API_STATUS } from "../../../constants/apiStatus";
import {
  getAllSubscriptionsAction,
  getSubscriptionsWithFiltersAction,
  getUserSubscriptionAction,
  createSubscriptionAction,
  updateSubscriptionAction,
  cancelSubscriptionAction,
} from "./subscriptionsSliceActions";
import { subscriptionsSliceInitialState } from "./subscriptionsSliceInitialState";

const initialState = subscriptionsSliceInitialState;

const subscriptionsSlice = createSlice({
  name: "subscriptions",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetSubscriptionsState: () => initialState,
  },
  extraReducers: (builder) => {
    // Get All Subscriptions
    builder.addCase(getAllSubscriptionsAction.fulfilled, (state, action) => {
      state.apiStatus.getAllSubscriptions = API_STATUS.COMPLETED;
      state.subscriptions = action.payload;
      state.error = null;
    });
    builder.addCase(getAllSubscriptionsAction.pending, (state) => {
      state.apiStatus.getAllSubscriptions = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(getAllSubscriptionsAction.rejected, (state, action) => {
      state.apiStatus.getAllSubscriptions = API_STATUS.FAILED;
      state.error = action.payload;
    });

    // Get Subscriptions with Filters
    builder.addCase(
      getSubscriptionsWithFiltersAction.fulfilled,
      (state, action) => {
        state.apiStatus.getSubscriptionsWithFilters = API_STATUS.COMPLETED;
        state.subscriptionsData = action.payload; // Store paginated data separately
        state.error = null;
      }
    );
    builder.addCase(getSubscriptionsWithFiltersAction.pending, (state) => {
      state.apiStatus.getSubscriptionsWithFilters = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(
      getSubscriptionsWithFiltersAction.rejected,
      (state, action) => {
        state.apiStatus.getSubscriptionsWithFilters = API_STATUS.FAILED;
        state.error = action.payload;
      }
    );

    // Get User Subscription
    builder.addCase(getUserSubscriptionAction.fulfilled, (state, action) => {
      state.apiStatus.getUserSubscription = API_STATUS.COMPLETED;
      state.userSubscription = action.payload;
      state.error = null;
    });
    builder.addCase(getUserSubscriptionAction.pending, (state) => {
      state.apiStatus.getUserSubscription = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(getUserSubscriptionAction.rejected, (state, action) => {
      state.apiStatus.getUserSubscription = API_STATUS.FAILED;
      state.error = action.payload;
    });

    // Create Subscription
    builder.addCase(createSubscriptionAction.fulfilled, (state, action) => {
      state.apiStatus.createSubscription = API_STATUS.COMPLETED;
      state.userSubscription = action.payload;
      state.error = null;
    });
    builder.addCase(createSubscriptionAction.pending, (state) => {
      state.apiStatus.createSubscription = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(createSubscriptionAction.rejected, (state, action) => {
      state.apiStatus.createSubscription = API_STATUS.FAILED;
      state.error = action.payload;
    });

    // Update Subscription
    builder.addCase(updateSubscriptionAction.fulfilled, (state, action) => {
      state.apiStatus.updateSubscription = API_STATUS.COMPLETED;
      state.userSubscription = action.payload;
      state.error = null;
    });
    builder.addCase(updateSubscriptionAction.pending, (state) => {
      state.apiStatus.updateSubscription = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(updateSubscriptionAction.rejected, (state, action) => {
      state.apiStatus.updateSubscription = API_STATUS.FAILED;
      state.error = action.payload;
    });

    // Cancel Subscription
    builder.addCase(cancelSubscriptionAction.fulfilled, (state, action) => {
      state.apiStatus.cancelSubscription = API_STATUS.COMPLETED;
      state.userSubscription = action.payload;
      state.error = null;
    });
    builder.addCase(cancelSubscriptionAction.pending, (state) => {
      state.apiStatus.cancelSubscription = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(cancelSubscriptionAction.rejected, (state, action) => {
      state.apiStatus.cancelSubscription = API_STATUS.FAILED;
      state.error = action.payload;
    });
  },
});

export const { clearError, resetSubscriptionsState } =
  subscriptionsSlice.actions;

export default subscriptionsSlice.reducer;
